import { render, staticRenderFns } from "./file-upload.vue?vue&type=template&id=0bd78df8"
import script from "./file-upload.vue?vue&type=script&lang=js"
export * from "./file-upload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports